<template>
	<div>
		<div class="container container--small pdt-50 ">
		<div class="t-headline11 font-m mgb-8 pdl-24 pdr-24">{{$t('770')}}</div>
		<div class="t-body1 t-color-bodyGrayA font-r pdl-24 pdr-24">{{$t('771')}}</div>
		<form @submit.prevent="next()" novalidate>
		<div class="mgt-40 pdl-24 pdr-24 position-relative">
			<label
				class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon  w-full customize-input h-46 mdc-text-field--disabled"
				data-mdc-auto-init="MDCTextField" id="emailEl">
				<span class="mdc-notched-outline">
					<span class="mdc-notched-outline__leading"></span>
					<span class="mdc-notched-outline__notch">
						<span class="mdc-floating-label" id="my-label-id"></span>
					</span>
					<span class="mdc-notched-outline__trailing"></span>
				</span>
				<input class="mdc-text-field__input t-color-disabledTextfieldText z-99" 
					type="email" aria-labelledby="my-label-id"
					v-model="join.socialId"
					disabled	
					>
				<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
					role="button">report_problem</i>
			</label>
			<!-- <div class="mdc-text-field-helper-line">
				<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
					id="my-helper-id" aria-hidden="true">
					
				</div>
			</div> -->
		</div>
		<!-- {{join.socialLink.userloginLanguage}}
		{{join.name.first}}
		{{join.name.last}} -->
		<div v-if="lang && (join.socialLink.userloginLanguage.toLowerCase() == 'ko' || lang.toLowerCase()=='ko') || lang && (join.socialLink.userloginLanguage.toLowerCase() == 'vi' || lang.toLowerCase()=='vi') || lang && (join.socialLink.userloginLanguage.toLowerCase() == 'ja' && lang.toLowerCase()=='ja') || lang && (join.socialLink.userloginLanguage.toLowerCase() == 'zh-cn' || lang.toLowerCase()=='zh-cn') || lang && (join.socialLink.userloginLanguage.toLowerCase() == 'zh-tw' || lang.toLowerCase()=='zh-tw') || lang && (join.socialLink.userloginLanguage.toLowerCase() == 'hu' || lang.toLowerCase()=='hu')">
			
			<div class="mgt-36 pdl-24 pdr-24 position-relative">
				<label
					class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 " :class="submitState && lastNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
					data-mdc-auto-init="MDCTextField" id="lastNameEl">
					<span class="mdc-notched-outline">
						<span class="mdc-notched-outline__leading"></span>
						<span class="mdc-notched-outline__notch">
							<span class="mdc-floating-label" id="my-label-id">{{$t('1610')}}</span>
						</span>
						<span class="mdc-notched-outline__trailing"></span>
					</span>
					<input class="mdc-text-field__input" type="text" 
							aria-labelledby="my-label-id"
							v-model="lastName"                            
							v-validate="'required'"
							ref="lastName"
							id="lastName"
							name="lastName"                           
						>
					<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
						role="button">report_problem</i>
				</label>
				<div class="mdc-text-field-helper-line">
					<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
						id="my-helper-id" aria-hidden="true" v-show="submitState && lastNameInvalidCheck">
						 {{$t('951')}}
					</div>
				</div>
			</div>

			<div class="mgt-36 pdl-24 pdr-24 position-relative">
				<label
					class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 " :class="submitState && firstNameInvalidCheck ? 'mdc-text-field--invalid' : ''"
					data-mdc-auto-init="MDCTextField" id="firstNameEl">
					<span class="mdc-notched-outline">
						<span class="mdc-notched-outline__leading"></span>
						<span class="mdc-notched-outline__notch">
							<span class="mdc-floating-label" id="my-label-id">{{$t('1611')}}</span>
						</span>
						<span class="mdc-notched-outline__trailing"></span>
					</span>
					<input class="mdc-text-field__input" 
							type="text" 
							aria-labelledby="my-label-id"
							v-model="firstName"
							v-validate="'required'"
							ref="firstName"
							id="firstName"
							name="firstName"
					>
					<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
						role="button">report_problem</i>
				</label>
				<div class="mdc-text-field-helper-line">
					<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
						id="my-helper-id" aria-hidden="true" v-show="submitState && firstNameInvalidCheck">
						 {{$t('952')}}
					</div>
				</div>
			</div>
			
		</div>
		<div v-else>
			<div class="mgt-36 pdl-24 pdr-24 position-relative">
				<label
					class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
					data-mdc-auto-init="MDCTextField" :class="submitState && firstNameInvalidCheck ? 'mdc-text-field--invalid' : ''" id="firstNameEl">
					<span class="mdc-notched-outline">
						<span class="mdc-notched-outline__leading"></span>
						<span class="mdc-notched-outline__notch">
							<span class="mdc-floating-label" id="my-label-id">{{$t('1611')}}</span>
						</span>
						<span class="mdc-notched-outline__trailing"></span>
					</span>
					<input class="mdc-text-field__input" 
							type="text" 
							aria-labelledby="my-label-id"
							v-model="firstName"
							v-validate="'required'"
							ref="firstName"
							id="firstName"
							name="firstName"
					>
					<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
						role="button">report_problem</i>
				</label>
				<div class="mdc-text-field-helper-line">
					<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
						id="my-helper-id" aria-hidden="true" v-show="submitState && firstNameInvalidCheck">
						 {{$t('952')}}
					</div>
				</div>
			</div>
			<div class="mgt-36 pdl-24 pdr-24 position-relative">
				<label
					class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
					data-mdc-auto-init="MDCTextField" :class="submitState && lastNameInvalidCheck ? 'mdc-text-field--invalid' : ''" id="lastNameEl">
					<span class="mdc-notched-outline">
						<span class="mdc-notched-outline__leading"></span>
						<span class="mdc-notched-outline__notch">
							<span class="mdc-floating-label" id="my-label-id">{{$t('1610')}}</span>
						</span>
						<span class="mdc-notched-outline__trailing"></span>
					</span>
					<input class="mdc-text-field__input" type="text" 
							aria-labelledby="my-label-id"
							v-model="lastName"                            
							v-validate="'required'"
							ref="lastName"
							id="lastName"
							name="lastName"
						>
					<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" tabindex="0"
						role="button">report_problem</i>
				</label>
				<div class="mdc-text-field-helper-line">
					<div class="mdc-text-field-helper-text mdc-text-field-helper-text--validation-msg t-helper font-r"
						id="my-helper-id" aria-hidden="true" v-show="submitState && lastNameInvalidCheck">
						 {{$t('951')}}
					</div>
				</div>
			</div>
		</div>
		<div class="mgt-30 mgb-50 pdl-24 pdr-24">
			<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body2 font-r">{{$t('1612')}}</span>
			</button>
			<button class="mdc-button t-color-secondaryBtnText" @click="cancelJoin()" @keypress="cancelJoin()" tabindex="0">
				<div class="mdc-button__ripple"></div>
				<span class="mdc-button__label t-body2 font-r">{{$t('1613')}}</span>
			</button>
		</div>
		</form>
		</div>
	</div>
</template>

<script>
/**
 * 회원가입 - 소셜 정보 확인 컴포넌트(sign up - check social information component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import joinApi from '@/api/joinApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'

export default {
	data() {
		return {
			emailTextField: null,
			firstNameTextField: null,
			lastNameTextField: null,
			firstName: null,
            lastName: null,
            lang :JSON.parse(localStorage.getItem('languageInfo')).code || this.join.socialLink.userloginLanguage,
            //lang :{code:'zh-CN'},
            returnValue:'',
            submitState: false,
			
		}
	},

	mixins: [joinMixin],

	computed : {
		...mapState('join',{
			join : state => state,
		}),

		firstNameInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('firstName')) {
                    returnValue = true
                    this.validIcon = 'warning'
                }else {
                    returnValue = false
                    this.validIcon = ''
                }
            }

            this.firstNameTextField.valid === !returnValue ? '' : this.firstNameTextField.valid = !returnValue
            return returnValue
        },

        // password validation check
        lastNameInvalidCheck() {
            let returnValue = false
            if (this.submitState) {
                if (this.errors.has('lastName')) {
                    returnValue = true
                    this.validIcon = 'warning'
                }else {
                    returnValue = false
                    this.validIcon = ''
                }
            }
            this.lastNameTextField.valid === !returnValue ? '' : this.lastNameTextField.valid = !returnValue
            return returnValue
        },
	},

	created() {
		if(this.join.socialLink.socialType=='apple') {
            this.firstName = ''
            this.lastName = ''
        } else if(this.join.socialLink.socialType=='telegram' || this.join.socialLink.socialType=='naver'){
            if(this.join.name.last =='') {
                this.lastName = ''
            } else {
                this.lastName = this.join.name.last
            }
            this.firstName = this.join.name.first
            this.socialId = this.join.socialId
        } else {
            this.firstName = this.join.name.first
            this.lastName = this.join.name.last
            this.socialId = this.join.socialId
        }
        
        if (
                !this.join.responsibility || 
                !this.join.terms.TERMS_OF_SERVICE  || 
                !this.join.socialId ||
                !this.join.socialLink.token || !this.join.socialLink.type

            ) {
             this.moveJoin2Intro()
        }
	},

	mounted() {
		this.setMaterialUi()
		
	},

	methods: {
		// Store 변이 정의(define store mutation)
		...mapMutations('join', ['SET_STORE', 'INIT_JOIN_STORE','SET_NAME_FIRST', 'SET_NAME_LAST','SET_NAME_FULL']),

		setMaterialUi() {
			this.emailTextField = new MDCTextField(document.querySelector('#emailEl'))
			this.emailTextField.useNativeValidation = false
			
			this.firstNameTextField = new MDCTextField(document.querySelector('#firstNameEl'))
			this.firstNameTextField.useNativeValidation = false

			this.lastNameTextField = new MDCTextField(document.querySelector('#lastNameEl'))
			this.lastNameTextField.useNativeValidation = false

			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

		

		// next
		next() {

			this.$validator.validateAll().then((resultValid) => {
				this.submitState = true
				if (resultValid) {
					this.SET_NAME_FIRST(this.firstName)
                    this.SET_NAME_LAST(this.lastName)
                    if(this.join.socialLink.socialType=='telegram' || this.join.socialLink.socialType=='naver') {
                        let fullName = this.firstName +' '+this.lastName
                        this.SET_NAME_FULL(fullName)
                    }
					this.$router.push({name: 'Join2Store'})
				} else{
					// this.focusFirstInvalidElement()
					// this.$snackOpen({
					// 	contents: this.$t('948'), //매장을 선택하세요.
					// 	btnDisplay: ''
					// }).then(() => {})
				}
			})
		},
	},
}
</script>